import { useCallback, useState } from 'react';

/*
 * Хук для управления состоянием, которое применяется не сразу, а по кнопке "Применить".
 * Управляет временным значением (для инпута) и примененным значением.
 * @param initialValue - Начальное значение.
 * @param onApply - Колбэк, который вызывается при применении нового значения.
 */
export const useStagedState = <T>(initialValue: T, onApply: (newValue: T) => void) => {
    const [appliedValue, setAppliedValue] = useState<T>(initialValue);
    const [tempValue, setTempValue] = useState<T>(initialValue);

    const applyValue = useCallback(
        (value: T) => {
            onApply(value);
            setAppliedValue(value);
            setTempValue(value);
        },
        [onApply]
    );

    const handleApply = useCallback(() => {
        applyValue(tempValue);
    }, [applyValue, tempValue]);

    const handleReset = useCallback(
        (resetValue: T) => {
            applyValue(resetValue);
        },
        [applyValue]
    );

    const isChanged = tempValue !== appliedValue;

    return {
        appliedValue,
        tempValue,
        setTempValue,
        applyValue,
        handleApply,
        handleReset,
        isChanged,
    };
};
